import { useContext, useRef, useState } from 'react';
import UserContext from '../helpers/UserContext';
import classes from './SignupForm.module.css';
import HTMLSelect from './HTMLSelect';
import qs from 'qs';
import axios from 'axios';
import { URL } from '../helpers/Options';
import PasswordForm from './PasswordForm';

function SignupForm( props ) {
	const userCtx = useContext(UserContext);
	const inputQty = useRef();
	const inputFirstName = useRef();
    const inputLastName = useRef();
	const inputEmail = useRef();
	const inputPassword = useRef();
	const message = useRef();
	const [svcHours, setSvcHours] = useState("🟩");
	const [passwordFormIsShown, showPasswordForm] = useState(false);
	const [submitClass, setSubmitClass] = useState(classes.active);
	const startQty = props.signupQty;
	const inputEmailConfirmation = useRef();
	const thePoster = (typeof props.poster === 'undefined') ? null : props.poster[0];
	const theText = (typeof props.poster === 'undefined') ? null : props.text[0];
	const theClass = (props.active) ? classes.signupContainer : classes.signupContainerClose;

	function submitHandler(event) {
		event.preventDefault();
		checkStatus();
		if (submitClass === classes.active) {
			var thePassword = 'NONE';
			var saveUserFlag = 'false';
			if (typeof inputPassword.current !== 'undefined') {
				thePassword = inputPassword.current.value;
				saveUserFlag = 'true';
			}
			const theEmail = inputEmail.current.value;
			const theLastName = inputLastName.current.value;
			const theFirstName = inputFirstName.current.value;
			const theFunction = (startQty>0) ? 'changeSignup'  : 'addSignup';
			const theQty = inputQty.current.value;
			const svcHourFlag = (svcHours === '🟩') ? "no" : "yes";
			var data = {
				action: 	'SAS_handleAJAX',
				function: 	theFunction,
				'createUser': saveUserFlag,
				'password':	thePassword,
				'activity':	props.id,
				'actName':	props.title,
				'deadline':	props.deadline,
				'recordID':	props.signupID,
				'fname':	theFirstName,
				'lname':	theLastName,
				'email':	theEmail,
				'svcHours':	svcHourFlag,
				'quantity':	theQty
			};
			console.log(data);
			
			axios.post(URL, qs.stringify(data)).then(
				function (response) {
					if (response.status === 200) {
						message.current.innerText = response.data;
						
						props.closeForm();
					}
				})
				.catch(function (error) {
					message.current.innerText = error.message+': '+message.current.innerText;
				});
			
		}
    }

	function setPassword() { showPasswordForm(true); allowSubmit(false) }

	function setSvcFlag() {
		if (svcHours === '🟩') { setSvcHours('✅') }
		else { setSvcHours('🟩') }
	}

	function allowSubmit(flag) {
		if (flag) { setSubmitClass(classes.active); }
		else {setSubmitClass(classes.inactive); }
	}

	function abortPW() {showPasswordForm(false);}

	var defaultFirstName = '';
	var defaultLastName = '';
	var defaultEmail = '';
	if (typeof userCtx.user.email !== 'undefined' && userCtx.user.email !== 'NONE') {
		defaultFirstName = userCtx.user.firstName;
		defaultLastName = userCtx.user.lastName;
		defaultEmail = userCtx.user.email;
	}
	else {
		defaultFirstName = '';
		defaultLastName = '';
		defaultEmail = '';
	
	}

	function logMessage(ref, text) {
		if (typeof ref === 'undefined' || ref.length===0) {
			const theMessage = 'Please enter your '+text+'. ';
			return theMessage;
		}
		else { return ''; }
	}

	function checkStatus() {
		var theMessage='';
		theMessage += logMessage(inputFirstName?.current?.value, 'first name');
		theMessage += logMessage(inputLastName?.current?.value, 'last name');
		theMessage += logMessage(inputEmail?.current?.value, 'email address');
		theMessage += logMessage(inputEmailConfirmation?.current?.value, 'email address confirmation');
		message.current.innerHTML = theMessage;
	}


	return(
		<div className={theClass}
		>
			<div className={classes.title}>
				<div>Signing up for {props.title}</div>
				<div onClick={props.closeForm} className={classes.closeBtn}>❌</div>
			</div>
			<form  className={classes.signupForm} onSubmit={submitHandler}>
				<label htmlFor="firstname" className={classes.nameLabel}>Name:</label>
				<input
					id="firstname"
					type="text"
					defaultValue={defaultFirstName}
					ref={inputFirstName}
					className={classes.nameInput}
				/>
				<input
					id="lastname"
					type="text"
					defaultValue={defaultLastName}
					ref={inputLastName}
					className={classes.nameInput}
				/>

				<label htmlFor="email" className={classes.emailLabel}>Email:</label>
				<input
					id="email"
					type="email"
					defaultValue={defaultEmail}
					ref={inputEmail}
					className={classes.email}
				/>
				<label htmlFor="emailConfirmation" className={classes.emailLabel}>Confirm Email:</label>
				<input
					id="emailConfirmation"
					type="email"
					defaultValue={defaultEmail}
					ref={inputEmailConfirmation}
					className={classes.email}
				/>
				
				<label className={classes.nameLabel}>Quantity:</label>
				<HTMLSelect 
					id={props.id} 
					limit={props.limit} 
					signupQty={props.signupQty} 
					onChange='updateQty' 
					ref={inputQty}
				/>
				<div onClick={setSvcFlag} className={classes.serviceLabel}>{svcHours} I'd like service hours</div>
				<div ref={message} className={classes.message}></div>
				
				{!passwordFormIsShown && props.signupQty===0 &&
					<button className={classes.saveInfo}	onClick={setPassword}>Save my information for next time.</button>
				}
				{passwordFormIsShown &&
					<PasswordForm
						key={"pwForm"}
						pwRef={inputPassword}
						allowSubmit={allowSubmit}
						abort={abortPW}
					/>}
				<button className={submitClass} type="submit">Submit</button>
			</form>
			<div>{theText}</div>
			<div className={classes.suggest}>See <a href={thePoster} rel="noreferrer" target={"_blank"}>
				 other card making suggestions.</a>
			</div>
		</div>
	)
}

export default SignupForm;